<template>
  <div class="dialog-content" ref="dialogContent" @scroll="checkScrollPosition">
    <div class="dialog-footer">
      <BaseButton
        @click="cancel"
        style="float: right; background-color: transparent;"
      >
        <i class="fas fa-times fa-2x"></i>
      </BaseButton>
    </div>
    <v-row class="dialog-body">
      <div>
        <table style="min-width: 100%; font-size: 12px">
          <tr>
            <td>
              <table
                style="
                  text-align: center;
                  min-width: 100%;
                  font-size: 12px;
                  min-height: 55px;
                  border-collapse: collapse;
                "
              >
                <tr
                  style="
                    background-color: #f2f2f2;
                    font-weight: bold;
                    min-width: 100%;
                  "
                >
                  <td style="width: 33%; text-align: left;">
                    <span>
                      <img
                        style="max-width: 30%; margin-left: 10px"
                        src="@/assets/Tagline_todo preto.png"
                      />
                    </span>
                  </td>
                  <td style="width: 33%">
                    <span style="text-align: center; font-size: 18px"
                      >Lockton Brasil</span
                    ><br />
                    <span style="text-align: center; font-size: 16px"
                      >Cotação de Seguro Agrícola</span
                    ><br />
                    <span style="text-align: center; font-size: 14px"
                      >Proteção e Segurança para o Produtor Rural</span
                    >
                  </td>
                  <td style="width: 33%; text-align: right">
                    <span
                      ><img
                        style="max-width: 30%; margin-right: 10px; max-height: 90px; margin-top: 6px"
                        :src="getLogoGrupoEconomico"
                      />
                    </span>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td class="section-title">
              <span style="margin-left: 5px">DADOS DO PROPONENTE</span>
            </td>
          </tr>
          <tr>
            <td>
              <table class="dados-proponente-table">
                <tr>
                  <th colspan="2">Nome</th>
                  <th>CPF/CNPJ</th>
                  <th>Telefone</th>
                  <th>Município do Risco</th>
                  <th>UF</th>
                </tr>
                <tr>
                  <td colspan="2">{{ formInsured.nome }}</td>
                  <td>{{ formInsured.numero_documento }}</td>
                  <td>{{ formInsured.celular }}</td>
                  <td>{{ formRisk.endereco.cidade }}</td>
                  <td>{{ formRisk.endereco.uf.sigla }}</td>
                </tr>
                <tr>
                  <th>Cultura</th>
                  <th>Tecnica de Plantio</th>
                  <th>Tipo de solo</th>
                  <th>Área do Risco (ha)</th>
                  <th colspan="2">Nome da Fazenda (Área)</th>
                </tr>
                <tr v-for="item in formRisk.agricola.items" :key="item.id">
                  <td>{{ currentQuotation.submodalidade.nome }}</td>
                  <td>{{ item.plantingTechniques.nome }}</td>
                  <td>{{ item.soilType.nome }}</td>
                  <td>{{ item.plantedArea }}</td>
                  <td colspan="2">{{ item.nome }}</td>
                </tr>
                <tr v-for="item in formRisk.cafezal.items" :key="item.id">
                  <td>{{ currentQuotation.submodalidade.nome }}</td>
                  <td>{{ item.especie.nome }}</td>
                  <td>{{ item.sistemaCultivo.nome }}</td>
                  <td>{{ item.areaPlantada }}</td>
                  <td colspan="2">{{ item.nome }}</td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <br />
          </tr>
          <tr>
            <td class="section-title">
              <span style="margin-left: 5px">
                DADOS DA COTAÇÃO ESCOLHIDA
              </span>
            </td>
          </tr>
          <tr>
            <td>
              <table class="cotacao-escolhida-table">
                <tr>
                  <td>Seguradora</td>
                  <td>Área Segurada (ha)</td>
                  <td>Regulação Sinistro</td>
                  <td>Coberturas</td>
                  <td>Importância segurada</td>
                  <td>Prod. Garantida (sc/ha)</td>
                  <td>Custo por Hectare</td>
                  <td>Preço Total</td>
                  <td>Subvenção Federal</td>
                  <td>Preço do Segurado</td>
                  <td>Preço Produtor (sc/ha)</td>
                  <td>Forma de Pagamento</td>
                </tr>
                <tr>
                  <td>{{ selectedItem.insuranceCompany.nome }}</td>
                  <td>{{ selectedItem.insuredArea }}</td>
                  <td>{{ selectedItem.claimType.nome }}</td>
                  <td>{{ selectedItem.coverage.nome }}</td>
                  <td>R$ {{ asNumberString(selectedItem.insuredValue) }}</td>
                  <td>{{ selectedItem.grantedProduction }}</td>
                  <td>R$ {{ asNumberString(selectedItem.costPerSac) }}</td>
                  <td>R$ {{ asNumberString(selectedItem.total) }}</td>
                  <td v-if="selectedItem.federalSubvention != null">
                    R$ {{ asNumberString(selectedItem.federalSubvention) }}
                  </td>
                  <td>R$ {{ asNumberString(selectedItem.insuredPrice) }}</td>
                  <td>R$ {{ asNumberString(selectedItem.farmerPrice) }}</td>
                  <td>{{ this.paymentForm.name }}</td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <br />
          </tr>
          <tr>
            <td>
              <table
                style="
                  font-size: 12px;
                  min-width: 100%;
                  border-collapse: collapse;
                  border: 1px solid black;
                "
              >
                <tr>
                  <td class="section-title">
                    <span style="margin-left: 5px;">
                      DETALHE DAS COBERTURAS
                    </span>
                  </td>
                </tr>
                <tr>
                  <td style="min-width: 100%; padding: 5px;">
                    <span style="color: #c00000; font-weight: bold"
                      >Cobertura Básica:
                    </span>
                    Contempla os seguintes riscos: Granizo, Seca, Geada,
                    Vendaval/Ventos Fortes, Tromba D´água, Chuva Excessiva,
                    Inundação/Alagamento, Variação Excessiva <br />
                    de Temperatura, Raio e Incêndio
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <br />
          </tr>
          <tr>
            <td>
              <table
                style="
                  font-size: 12px;
                  min-width: 100%;
                  border-collapse: collapse;
                  border: 1px solid black;
                "
              >
                <tr>
                  <td class="section-title">
                    <span style="margin-left: 5px;">
                      CARÊNCIA DAS COBERTURAS
                    </span>
                  </td>
                </tr>
                <tr>
                  <td style="min-width: 100%; padding: 5px;">
                    <span style="color: #c00000; font-weight: bold">
                      Cobertura Básica:
                    </span>
                    O período de carência será até que no mínimo 60% das plantas
                    atinjam uma altura a partir do nível do solo superior a 15
                    cm para Algodão, Girassol, Milho, Feijão e Soja e altura
                    superior a 10 cm para Trigo, Canola e Cevada. Caso a cultura
                    esteja plantada, a carência será de 24 horas apartir do
                    início de vigência da apólice, sempre que no mínimo 60% das
                    plantas atinjam uma altura a partir do nível do solo
                    superior a 15 cm para Algodão, Girassol, Milho, Feijão e
                    Soja e altura superior a 10 cm para Trigo, Canola e Cevada.
                    <br />
                    <span style="color: #c00000; font-weight: bold">
                      Cobertura Adicional:
                    </span>
                    Inicio de Vigência da Cobertura: 7 (sete) dias após a
                    semeadura, ou quando 60% da área total contratada estiver
                    emergida, e termina com início da cobertura básica e/ou
                    Prazo Final de Plantio do Zoneamento Agrícola do MAPA, para
                    a cultura segurada.
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <br />
          </tr>
          <tr>
            <td>
              <table
                style="
                  font-size: 12px;
                  min-width: 100%;
                  border-collapse: collapse;
                  border: 1px solid black;
                "
              >
                <tr>
                  <td class="section-title">
                    <span style="margin-left: 5px;">
                      FORMA DE REGULAÇÃO DO SINISTRO
                    </span>
                  </td>
                </tr>
                <tr>
                  <td style="min-width: 100%; padding: 5px;">
                    <span style="color: #c00000; font-weight: bold">
                      Média da Área Total:
                    </span>
                    Em caso de sinistro a regulação será pela média da área
                    total, ou seja, o cálculo de indenização será efetuado com
                    base na produtvidade média de toda a área segurada.
                    <br />
                    <span style="color: #c00000; font-weight: bold">
                      Regulação por Talhão/Item:
                    </span>
                    A Seguradora Newe apresentou condições com regulação por
                    talhão com área mínima de 30 hectares. Os talhões/itens
                    precisam apresentar entre eles separação física por estrada,
                    rodovia, matas/florestas, outras culturas, lago ou rio.
                    Estradas internas e carreadores NÃO serão consideradas
                    suficientes para separação física de itens. Na Seguradora
                    Sompo os talhões serão divididos conforme croqui
                    apresentado.
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <br />
          </tr>
          <tr v-if="this.currentQuotation.itens_agricola.length > 0">
            <td>
              <table
                style="
                  font-size: 12px;
                  min-width: 100%;
                  border-collapse: collapse;
                  border: 1px solid black;
                "
              >
                <tr>
                  <td
                    v-html="formatText(currentQuotation.informacoes_adicionais)"
                  ></td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <br />
          </tr>
          <tr>
            <td>
              <tr class="info-section-title">
                <td>
                  <span style="margin-left: 5px;">
                    INFORMAÇÕES ADICIONAIS
                  </span>
                </td>
              </tr>
              <table class="info-section-table">
                <tr>
                  <td>
                    Esta proposta de seguro poderá ser submetida ao Ministério
                    da Agricultura, Pecuária e Abastecimento - MAPA para
                    verificação quanto à concessão de subvenção ao prêmio de
                    seguro rural do Governo Federal, conforme os critérios
                    exigidos pelo Programa, que devem ser atendidos
                    integralmente pelo Proponente/Segurado. Caso a proposta não
                    se enquadre nas regras vigentes do programa ou o MAPA não
                    conceda, ou conceda parcialmente, o subsídio, o pagamento
                    correspondente ao valor não obtido da subvenção federal ao
                    prêmio líquido do seguro será de inteira responsabilidade do
                    Proponente/Segurado. Nesse caso, o Proponente/Segurado
                    deverá efetuar o pagamento da parcela correspondente à
                    subvenção, no vencimento previsto em boleto a ser enviado
                    pela seguradora, restando acordado desde já que o não
                    pagamento desta parcela determinará a redução da vigência da
                    apólice.
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <br />
          </tr>
          <tr>
            <td>
              <tr class="info-section-title">
                <td>
                  <span style="margin-left: 5px;">SUBVENÇÃO FEDERAL</span>
                </td>
              </tr>
              <table class="info-section-table">
                <tr>
                  <td>
                    Esta proposta de seguro poderá ser submetida ao Ministério
                    da Agricultura, Pecuária e Abastecimento - MAPA para
                    verificação quanto à concessão de subvenção ao prêmio de
                    seguro rural do Governo Federal, conforme os critérios
                    exigidos pelo Programa, que devem ser atendidos
                    integralmente pelo Proponente/Segurado. Caso a proposta não
                    se enquadre nas regras vigentes do programa ou o MAPA não
                    conceda, ou conceda parcialmente, o subsídio, o pagamento
                    correspondente ao valor não obtido da subvenção federal ao
                    prêmio líquido do seguro será de inteira responsabilidade do
                    Proponente/Segurado. Nesse caso, o Proponente/Segurado
                    deverá efetuar o pagamento da parcela correspondente à
                    subvenção, no vencimento previsto em boleto a ser enviado
                    pela seguradora, restando acordado desde já que o não
                    pagamento desta parcela determinará a redução da vigência da
                    apólice.
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <br />
          </tr>
          <tr>
            <td>
              <tr class="info-section-title">
                <td>
                  <span style="margin-left: 5px;">
                    SUSEP – SUPERINTENDÊNCIA DE SEGUROS PRIVADOS
                  </span>
                </td>
              </tr>
              <table class="info-section-table">
                <tr>
                  <td>
                    A SUSEP é o órgão responsável pela regulamentação e
                    fiscalização das operações das seguradoras, sujeitas às leis
                    e regulamentos no Brasil, inclusive referentes à solvência.
                    Em atendimento as disposições contidas na Resolução CNSP no
                    382/2020, a comissão de corretagem para esta colocação é de
                    {{ selectedItem.comissao }} porcento. Havendo interesse em
                    obter mais informações sobre alguma seguradora em
                    particular, incluindo informação sobre suas finanças e
                    solvência, por favor, consulte diretamente a SUSEP.
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <br />
          </tr>
          <tr>
            <td>
              <tr class="info-section-title">
                <td>
                  <span style="margin-left: 5px;">
                    DIVULGAÇÃO E CONFIRMAÇÃO DE INFORMAÇÕES
                  </span>
                </td>
              </tr>
              <table class="info-section-table">
                <tr>
                  <td>
                    Esta proposta foi produzida com base nas informações
                    disponibilizadas por você, e por esta razão, a Lockton não
                    assumirá qualquer responsabilidade decorrente da imprecisão
                    dos dados recebidos ou as recomendações baseadas na
                    informação fornecida. Este documento não oferece qualquer
                    recomendação legal, contábil ou tributária. Você, segurado
                    deve fornecer todas as informações relacionadas ao risco do
                    seu negócio e que possam afetar o julgamento da seguradora
                    na aceitação do risco, a determinação do prêmio do seguro,
                    as condições e cláusulas da apólice; caso as referidas
                    informações não forem divulgadas, quando da ocorrência de
                    sinistro o a Seguradora poderá anular indenizações desde o
                    início de sua vigência ou mesmo não acatar sinistros
                    ocorridos, em conformidade com o Artigo 766 do Código Civil.
                    Lembramos que este documento é confidencial e
                    terminantemente proibido sua divulgação parcial ou total a
                    terceiros sem a expressa autorização da Lockton. A Lockton
                    Brasil seguindo a política mundial do grupo, possui um
                    conjunto de princípios que compõem as bases do
                    relacionamento comercial com os nossos Clientes, definindo
                    em linhas gerais, nossos processos internos e critérios de
                    colocação de riscos e administração de seguros.
                    <a href="http://" target="_blank" rel="noopener noreferrer">
                      Para saber mais CLIQUE AQUI.
                    </a>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </div>
    </v-row>
    <BaseFooter class="dialog-footer" v-if="selectedItem">
      <div class="d-flex justify-end">
        <BaseButton
          class="text-uppercase"
          color="secondary"
          outlined
          min-width="200"
          @click="cancel"
        >
          Voltar
        </BaseButton>
        <BaseButton
          class="secondary text-uppercase subtitle-2 ml-5"
          min-width="200"
          :disabled="!isScrolledToBottom"
          @click="accept"
        >
          Aceitar
        </BaseButton>
        <v-tooltip
          bottom
          content-class="tooltip-label-form"
          v-if="!isScrolledToBottom"
        >
          <template v-slot:activator="{ on }">
            <v-icon class="ml-2" color="secondary" size="14" v-on="on">
              fa-info-circle
            </v-icon>
          </template>
          <v-row>
            <v-col cols="12" class="px-4 py-3">
              <p class="white--text tooltip-label-text mb-0">
                Para aceitar, visualize todo o documento.
              </p>
            </v-col>
          </v-row>
        </v-tooltip>
      </div>
    </BaseFooter>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import { QuotationMixin } from "@/mixins/NewQuotationMixin";
import { asNumberString } from "@/utils/formats.js";
export default {
  name: "QuotationAgroModal",
  data() {
    return {
      asNumberString,
      isScrolledToBottom: false
    };
  },
  mixins: [LoadingRequest, QuotationMixin],
  computed: {
    ...mapState("quotation", ["currentQuotation"]),
    getLogoGrupoEconomico() {
      return this.currentQuotation.grupo_economico?.logo_url;
    }
  },
  methods: {
    ...mapActions("quotation", ["requestApproveDraftContractQuotationAgro"]),
    accept() {
      this.submitApproveDraftContract();
      this.$emit("accept", this.selectedItem);
    },
    cancel() {
      this.$emit("cancel");
    },
    submitApproveDraftContract() {
      let value = {
        id: this.selectedItem.id,
        payload: {
          forma_pagamento: this.paymentForm.id.toString()
        }
      };
      this.withLoading(
        this.requestApproveDraftContractQuotationAgro(value)
        // => { this.$emit("accept", this.selectedItem.id); })
      );
    },
    checkScrollPosition() {
      const contentElement = this.$refs.dialogContent;
      const isAtBottom =
        contentElement.scrollTop + contentElement.offsetHeight >=
        contentElement.scrollHeight - 10;
      this.isScrolledToBottom = isAtBottom;
    },
    formatText(text) {
      if (text == null) {
        return "";
      }

      const lines = text.split("  ");
      const firstLine = `<span style="background-color: black; color: white; display: block;">${lines[0].toUpperCase()}</span>`;
      const remainingLines = lines.slice(1).filter(line => line.trim() !== "");
      const formattedText = [firstLine, ...remainingLines].join("  ");

      return formattedText;
    }
  },
  props: {
    selectedItem: {
      type: Object,
      default: null
    },
    formInsured: {
      type: Object
    },
    formCost: {
      type: Object
    },
    formProduct: {
      type: Object
    },
    formRisk: {
      type: Object
    },
    paymentForm: {
      type: Object
    }
  }
};
</script>
<style lang="sass" scoped>
.dialog-content
  display: flex
  flex-direction: column
  height: 500px
  background-color: white
  overflow-y: scroll
.dialog-body
  flex-grow: 1
.dialog-footer
  margin-top: auto
  position: sticky
  bottom: 0
  background-color: white
  padding: 10px
.tooltip
  position: absolute
  top: -30px
  left: 50%
  transform: translateX(-50%)
  color: #ef5350
  border-radius: 5px
  font-size: 11px
.dados-proponente-table
  font-size: 12px
  min-width: 100%
  border-spacing: 14px 6px
  tr
    text-align: left
    th
      font-weight: 500
    td
      background-color: #f7f7f7
      border-bottom:  2px solid #727272
      font-weight: 500
.cotacao-escolhida-table
  font-size: 12px
  min-width: 100%
  border-collapse: collapse
  tr
    text-align: left
    font-size: 12px
    th
      text-align: center
      background-color: #f2f2f2
      border: 1px solid black
      padding: 2px 4px
      font-weight: 400
    td
      text-align: center
      border: 1px solid black
      padding: 3px 6px
.section-title
  background-color: black
  color: white
  min-width: 100%
  min-height: 15px
  text-align: left
.info-section-title
  display: flex
  td
    background-color: #c00000
    color: white
    text-align: left
    width: 380px
.info-section-table
  font-size: 12px
  border-collapse: collapse
  border: 1px solid black
  min-width: 100%
  td
    min-width: 100%
    padding: 5px
</style>
